import type { DidBiometryResponse, DidBiometryRetryResponse, DidSignMainDocsResponse } from 'share/types/api/biometry'

import { api } from '.'

const biometryApi = api.injectEndpoints({
  endpoints: build => ({
    startForensics: build.mutation<DidBiometryResponse, string>({
      query: uuid => ({
        url: `/biometry/${uuid}/forensics-biometry-start/`,
        method: 'post'
      })
    }),
    verifyForensics: build.mutation<void, string>({
      query: uuid => ({
        url: `/biometry/${uuid}/forensics-biometry-verify/`,
        method: 'post'
      })
    }),
    startAituBiomety: build.mutation<DidBiometryResponse, string>({
      query: uuid => ({
        url: `/biometry/${uuid}/did-biometry-start/`,
        method: 'post'
      })
    }),
    signDidBiometryRepaymentSchedule: build.mutation<{ data: { url: string } }, string>({
      query: id => ({
        url: `/biometry/${id}/did-biometry-sign-repayment-schedule/`,
        method: 'post'
      })
    }),
    didBiometryRetry: build.mutation<DidBiometryRetryResponse, string>({
      query: uuid => ({
        url: `biometry/${uuid}/did-biometry-retry/`,
        method: 'post'
      })
    }),
    didDamuSignMainDocs: build.mutation<DidSignMainDocsResponse, string>({
      query: flow_uuid => ({
        url: `biometry/${flow_uuid}/did-damu-sign-main_docs-borrower/`,
        method: 'post'
      })
    }),
    didSignMainDocs: build.mutation<DidSignMainDocsResponse, string>({
      query: flow_uuid => ({
        url: `biometry/${flow_uuid}/did-sign-main_docs-borrower/`,
        method: 'post'
      })
    }),
    didPledgeSignMainDocs: build.mutation<DidSignMainDocsResponse, string>({
      query: flow_uuid => ({
        url: `biometry/${flow_uuid}/did-pledge-sign-main_docs-borrower/`,
        method: 'post'
      })
    }),
    CCBorrowerSign: build.mutation<void, string>({
      query: flow_uuid => ({
        url: `biometry/${flow_uuid}/cc-sign-main_docs-borrower/`,
        method: 'post'
      })
    }),
    CCPledgeBorrowerSign: build.mutation<void, string>({
      query: flow_uuid => ({
        url: `biometry/${flow_uuid}/cc-pledge-sign-main_docs-borrower/`,
        method: 'post'
      })
    }),
    CCOwnBorrowerSign: build.mutation<void, string>({
      query: flow_uuid => ({
        url: `biometry/${flow_uuid}/cc-own-sign-main-docs-borrower/`,
        method: 'post'
      })
    }),
    startSignBorrowerForensics: build.mutation<DidBiometryResponse, string>({
      query: uuid => ({
        url: `/biometry/${uuid}/sign-borrower-forensics-biometry-start/`,
        method: 'post'
      })
    }),
    verifySignBorrowerForensics: build.mutation<void, string>({
      query: uuid => ({
        url: `/biometry/${uuid}/sign-borrower-forensics-biometry-verify/`,
        method: 'post'
      })
    })
  })
})

export const {
  useStartForensicsMutation,
  useVerifyForensicsMutation,
  useStartAituBiometyMutation,
  useSignDidBiometryRepaymentScheduleMutation,
  useDidBiometryRetryMutation,
  useDidSignMainDocsMutation,
  useDidDamuSignMainDocsMutation,
  useDidPledgeSignMainDocsMutation,
  useCCBorrowerSignMutation,
  useCCPledgeBorrowerSignMutation,
  useCCOwnBorrowerSignMutation,
  useStartSignBorrowerForensicsMutation,
  useVerifySignBorrowerForensicsMutation
} = biometryApi
